import angular from 'angular';
import userRoutingModule from 'user/user-routing-module';
import userErrorCodesModule from 'user/config/errorcodes.conf';
import myAccountModule from 'user/components/my-account/my-account-module';
import manageUsersModule from 'user/components/manage-users/manage-users-component';
import editAccountModule from 'user/components/edit-account/edit-account-component';
import createAccountStepsModule from 'user/components/create-account-steps/create-account-steps-component';
import changePrimaryUserModule from 'user/components/change-primary-user/change-primary-user-component';
import retailerSettingsModule from 'user/components/retailer-settings/retailer-settings-module';
import securityModule from 'security/security-module';
import authModule from 'auth/auth-module';

export default angular.module('user', [
  userRoutingModule.name,
  userErrorCodesModule.name,
  myAccountModule.name,
  manageUsersModule.name,
  editAccountModule.name,
  createAccountStepsModule.name,
  changePrimaryUserModule.name,
  retailerSettingsModule.name,
  securityModule.name,
  authModule.name,
]);



// WEBPACK FOOTER //
// ./src/modules/user/user-module.js